/* eslint-disable multiline-ternary */
import React from 'react'
import { HouseTwoTone } from '@mui/icons-material'
import {
  IconButton,
  Breadcrumbs as MuiBreadcrumbs,
  Typography
  , Skeleton,
  Tooltip
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import Link from '../link'
import { categoryUrl } from '../../helpers/url'
import { useHome } from '../../hooks'

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  root: {
    color: palette.grey[70],
    marginLeft: spacing(-1),
    '& .MuiLink-root': {
      textTransform: 'capitalize',
      ...typography.body.xs,
      fontWeight: typography.fontWeightMedium,
      padding: spacing(0, 1),
      textAlign: 'start'
    },
    '& .MuiIconButton-root': {
      paddingTop: spacing(1),
      paddingBottom: spacing(1)
    },
    '& .MuiSkeleton-root': {
      margin: spacing(1)
    }
  }
}))

const Breadcrumbs = ({
  path = [],
  className = '',
  loading = false,
  onClick = () => {}
}) => {
  const classes = useStyles()
  const { linkProps } = useHome()
  const last = path.length - 1

  if (loading) {
    return (
      <MuiBreadcrumbs
        data-test='breadcrumbs'
        separator=''
        aria-label='breadcrumbs'
        classes={{ root: classes.root }}
      >
        <Skeleton variant='rectangle' width={40} height='1em' />
        <Skeleton variant='rectangle' width={120} height='1em' />
        <Skeleton variant='rectangle' width={120} height='1em' />
        <Skeleton variant='rectangle' width={150} height='1em' />
      </MuiBreadcrumbs>
    )
  }

  return (
    <MuiBreadcrumbs
      data-test='breadcrumbs'
      classes={{ root: classes.root }}
      className={className}
      separator='>'
    >
      <Tooltip title='Go to Home'>
        <IconButton
          data-test='breadcrumbs-home'
          color='inherit'
          aria-label='Home'
          size='large'
          {...(last === 0 ? { 'aria-current': 'page' } : {})}
          {...linkProps}
        >
          <HouseTwoTone fontSize='small' />
        </IconButton>
      </Tooltip>

      {path.slice().reverse().map((category, idx) => {
        const { name, sk } = category
        return (
          <Link
            key={sk ?? idx}
            to={categoryUrl(category, path)}
            onClick={() => onClick(category)}
            disabled={idx === 0}
            data-test={`breadcrumbs-category-${sk}`}
            underline='none'
            {...(idx === last ? {
              'aria-current': 'page',
              color: 'primary',
              component: Typography,
              onClick: () => {}
            } : {})}
          >
            {name ?? <Skeleton width='4.5em' />}
          </Link>
        )
      })}
    </MuiBreadcrumbs>
  )
}

export default Breadcrumbs
